import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class KgboxPresale extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  /**
   * Refreshes the pre-sale panel from the same selected-variant section response used by the product form.
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newPresale = detail.html.querySelector(`kgbox-presale[data-block-id="${this.dataset.blockId}"]`);
        if (!newPresale) return;

        morph(this, newPresale, { childrenOnly: true });
        this.toggleAttribute('hidden', newPresale.hasAttribute('hidden'));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[kgbox-presale] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('kgbox-presale')) {
  customElements.define('kgbox-presale', KgboxPresale);
}
